"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var split_1 = require("../split");
var AxisComponentPart = /** @class */ (function (_super) {
    __extends(AxisComponentPart, _super);
    function AxisComponentPart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AxisComponentPart;
}(split_1.Split));
exports.AxisComponentPart = AxisComponentPart;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBpbGUvYXhpcy9jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBRUEsa0NBQStCO0FBRS9CO0lBQXVDLHFDQUFzQjtJQUE3RDs7SUFBK0QsQ0FBQztJQUFELHdCQUFDO0FBQUQsQ0FBQyxBQUFoRSxDQUF1QyxhQUFLLEdBQW9CO0FBQW5ELDhDQUFpQiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7QXhpc30gZnJvbSAnLi4vLi4vYXhpcyc7XG5pbXBvcnQge1ZnQXhpc30gZnJvbSAnLi4vLi4vdmVnYS5zY2hlbWEnO1xuaW1wb3J0IHtTcGxpdH0gZnJvbSAnLi4vc3BsaXQnO1xuXG5leHBvcnQgY2xhc3MgQXhpc0NvbXBvbmVudFBhcnQgZXh0ZW5kcyBTcGxpdDxQYXJ0aWFsPFZnQXhpcz4+IHt9XG5cbmV4cG9ydCBpbnRlcmZhY2UgQXhpc0NvbXBvbmVudCB7XG4gIG1haW4/OiBBeGlzQ29tcG9uZW50UGFydDtcbiAgZ3JpZD86IEF4aXNDb21wb25lbnRQYXJ0O1xufVxuXG5leHBvcnQgaW50ZXJmYWNlIEF4aXNDb21wb25lbnRJbmRleCB7XG4gIHg/OiBBeGlzQ29tcG9uZW50W107XG4gIHk/OiBBeGlzQ29tcG9uZW50W107XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgQXhpc0luZGV4IHtcbiAgeD86IEF4aXM7XG4gIHk/OiBBeGlzO1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/vega-lite/build/src/compile/axis/component.js
// module id = 1363
// module chunks = 0